class NSSPhotoStack extends HTMLElement {

  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Photo Stack] Connected.");

    const photoEls = this.querySelectorAll(`.nss-photo-stack__photo`);
    photoEls.forEach((photoEl) => {
      this.randomRotate(photoEl);
      photoEl.addEventListener(`click`, (e) => {
        e.target.style.opacity = `0`;
        e.target.style.transform = `translateY(50px) scale(0.9)`;
        
        setTimeout(() => {
          this.insertBefore(e.target, this.firstChild);
        }, 250);

        setTimeout(() => {
          e.target.style.opacity = `1`;
          this.randomRotate(e.target);
        }, 1000);
      });
    });
  }

  randomRotate(photoEl) {
    let randMin = -10.00,
        randMax = 10.00,
        degrees = (Math.random() * (randMax - randMin) + randMin).toFixed(4),
        dist    = degrees * 2;
    photoEl.style.transform = `rotate(${degrees}deg) translateY(${dist}px) translateX(${dist}px) scale(0.9)`;
  }
}

let elementName = `nss-photo-stack`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPhotoStack);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}